import { Table, TableContainer, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import { CODES } from '../../../utils/responseCodes';
import VacationService from '../../../services/vacation';
import { IconButton } from '@mui/material';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import ThumbUpAltTwoToneIcon from '@mui/icons-material/ThumbUpAltTwoTone';
import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { Toast } from '../../../utils/alerts';
import { calcularDiferenciaDias } from '../../../utils/function';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { green, red } from '@mui/material/colors';
import VerificationModal from '../../components/Vacaciones/VerificationModal';

export function BallotTable({ Papeletas, TabMisAprobaciones = true, cambiarLoader, QuePapeletasCargar, correo }) { //EsGerencia = false
    const [actualizarPapeleta, setActualizarPapeleta] = useState(0)
    const [editandoFilaId, setEditandoFilaId] = useState(null);
    const [valoresEditados, setValoresEditados] = useState({});
    const [diasTomadosEditados, setDiasTomadosEditados] = useState({});
    const [erroresFechas, setErroresFechas] = useState({});
    const [modalAbierto, setModalAbierto] = useState(false);
    const columns = [
        { id: '#', label: '#', minWidth: 20, },
        ...(TabMisAprobaciones ? [{ id: 'nombre', label: 'Nombre', minWidth: 100, align: 'center' }] : []),
        { id: 'n_papeleta', label: 'n° papeleta', minWidth: 60, align: 'center', },
        { id: 'fecha_salida', label: 'Fecha de Salida', minWidth: 80, align: 'center', type: 'icon' },
        { id: 'fecha_reincorporacion', label: 'Fecha de reincorporacion', minWidth: 60, align: 'center', type: 'icon' },
        { id: 'n_diasTomados', label: 'Total de dias tomados', minWidth: 60, align: 'center', type: 'icon' },
        { id: 'fecha_registro', label: 'Fecha de registro', minWidth: 60, align: 'center', type: 'icon' },
        { id: 'estado', label: 'Estado', minWidth: 40, align: 'center' },
        { id: 'acciones', label: 'Acciones', minWidth: 120, align: 'center' }
    ];

    const download_papeleta = async (papeletaID) => {
        try {
            cambiarLoader(true);
            const response = await VacationService.downloadBallotByid(papeletaID);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // Abre el PDF en una nueva pestaña
            window.open(url, '_blank');

            // Crea un enlace oculto para descargar el PDF
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `papeleta-${papeletaID}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Liberar el objeto URL
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        } catch (error) {
            console.error('Error al abrir o descargar la papeleta:', error);
        } finally {
            cambiarLoader(false);
        }
    };

    async function EditarFechaPapeleta(id_papeleta) {
        // const LasFechasAactualizar = { ...valoresEditados, id_papeleta: id_papeleta  };
        const cambios = valoresEditados[id_papeleta] || {};
        const dias = diasTomadosEditados[id_papeleta];
        const salida = cambios.fecha_salida;
        const retorno = cambios.fecha_reincorporacion;
        const hoy = new Date().toISOString().split('T')[0]; // formato YYYY-MM-DD
        let errores = {};
        if (salida && salida < hoy) {
            errores.fecha_salida = true;
            Toast.fire({
                icon: 'error',
                title: 'La fecha de salida debe ser posterior a hoy.'
            });
        }
        if (retorno && retorno < hoy) {
            errores.fecha_reincorporacion = true;
            Toast.fire({
                icon: 'error',
                title: 'La fecha de reincorporación debe ser posterior a hoy.'
            });
        }
        if (salida && retorno && salida > retorno) {
            errores.fecha_reincorporacion = true;
            Toast.fire({
                icon: 'error',
                title: 'La fecha de reincorporación no debe ser anterior a la fecha de salida.'
            });
        }
        if (dias !== undefined && dias <= 0) {
            Toast.fire({
                icon: 'error',
                title: 'Debes ingresar al menos un día tomado.'
            });
            return; // sin setErrores, porque es un error de lógica, no visual de campo
        }
        // Si hay errores visuales en campos:
        if (Object.keys(errores).length > 0) {
            setErroresFechas(prev => ({
                ...prev,
                [id_papeleta]: errores
            }));
            return; // cancelamos el envío
        }
        // setErroresFechas(prev => {
        //     const nuevo = { ...prev };
        //     delete nuevo[id_papeleta];
        //     return nuevo;
        // });
        const payload = {
            id_papeleta,
            ...cambios,
            ...(dias !== undefined ? { n_diasTomados: dias } : {})
        };
        // Mensaje de no has editado nada aun
        try {
            cambiarLoader(true);
            const response = await VacationService.UpdateBallot(payload);
            QuePapeletasCargar();
            if (response?.status === CODES.SUCCESS_200) {
                Toast.fire({
                    icon: 'success',
                    title: (response?.data.message)
                });
            } else {
                Toast.fire({
                    icon: 'error',
                    title: (response?.message || 'Error en el estado de la respuesta')
                });
            }
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: `Error al actualizar la papeleta: ${error?.response?.data?.message}`
            });
        } finally {
            setEditandoFilaId(null);
            setValoresEditados({});
            setDiasTomadosEditados({})
            cambiarLoader(false);
        }
    }

    async function EnviarToken(id_papeleta) {
        setActualizarPapeleta(id_papeleta);
        setModalAbierto(true);
        try {
            cambiarLoader(true);
            const result = await VacationService.sendToken();
            Toast.fire({
                icon: 'success',
                title: result.message
            });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'No se envió el correo, por favor vuélvalo a intentar.'
            });
            console.error(error);
        } finally {
            cambiarLoader(false);
        }
        // }
    }

    const DesaprobarPapeleta = async (id_papeleta, estado) => {
        const confirmacion = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción marcará la papeleta como desaprobada.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, desaprobar',
            cancelButtonText: 'Cancelar',
            showClass: {
                popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
                popup: "animate__animated animate__fadeOutUp",
            },
        });
        const payload = { id_papeleta, estado }
        if (confirmacion.isConfirmed) {
            try {
                cambiarLoader(true);
                const response = await VacationService.UpdateBallot(payload);
                QuePapeletasCargar();
                if (response?.status === CODES.SUCCESS_200) {
                    Toast.fire({
                        icon: 'success',
                        title: (response?.data.message)
                    });
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: (response?.message || 'Error en el estado de la respuesta')
                    });
                }
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: `Error al actualizar la papeleta: ${error?.response?.data?.message}`
                });
            } finally {
                setEditandoFilaId(null);
                setValoresEditados({});
                setDiasTomadosEditados({})
                cambiarLoader(false);
            }
        }
    };

    const EditaronFechas = (campo, valor, datosOriginales) => {
        // console.log(datosOriginales)};
        setErroresFechas({});
        setValoresEditados(prev => {
            const prevCampos = prev[datosOriginales.id_papeleta] || {};
            const otroCampo = campo === 'fecha_salida' ? 'fecha_reincorporacion' : 'fecha_salida';
            const nuevaFecha = {
                ...prevCampos,
                [campo]: valor,
                ...(!(otroCampo in prevCampos) ? { [otroCampo]: datosOriginales[otroCampo] } : {})
            };
            // Calcular días si tenemos ambas fechas
            const salida = nuevaFecha.fecha_salida;
            const retorno = nuevaFecha.fecha_reincorporacion;

            if (salida && retorno) {
                const dias = calcularDiferenciaDias(salida, retorno) >= 0 ? calcularDiferenciaDias(salida, retorno) : 0;
                setDiasTomadosEditados(prevDias => ({
                    ...prevDias,
                    [datosOriginales.id_papeleta]: dias
                }));
            }
            return {
                ...prev,
                [datosOriginales.id_papeleta]: nuevaFecha
            };
        });
    };

    return (
        <div className='page-body-main'>
            <div className='page-body__table' style={{ overflow: 'hidden' }}>
                <div className='page-body-table'>
                    <TableContainer className='table-height'>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Papeletas?.map((row, index) => {
                                    const getRowStyle = (estado) => {
                                        if (estado === '2') {
                                            return { backgroundColor: green[100] };
                                        }
                                        if (estado === '3') {
                                            return { backgroundColor: red[100] };
                                        }
                                        return {}; // Sin fondo para otros estados
                                    };
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={"row" + index} sx={getRowStyle(row.estado)} >
                                            {columns.map((col) => {
                                                const esEditable = (editandoFilaId === row.id_papeleta) ? true : false;
                                                if (col.id === '#') {
                                                    return <TableCell key={col.id}> {index + 1} </TableCell>;
                                                }
                                                if (col.id === 'fecha_salida' || col.id === 'fecha_reincorporacion') {
                                                    return (
                                                        <TableCell key={col.id} align="center">
                                                            {/* {console.log(row)} */}
                                                            {esEditable ? (
                                                                <TextField
                                                                    size="small"
                                                                    type="date"
                                                                    defaultValue={row[col.id] || ''}
                                                                    onChange={(e) =>
                                                                        EditaronFechas(col.id, e.target.value, row)
                                                                    }
                                                                    // InputLabelProps={{ shrink: true }}
                                                                    error={erroresFechas[row.id_papeleta]?.[col.id] || false}
                                                                    helperText={erroresFechas[row.id_papeleta]?.[col.id] ? 'Fecha inválida' : ''}
                                                                />
                                                            ) : (
                                                                row[col.id] || '-'
                                                            )}
                                                        </TableCell>
                                                    );
                                                }
                                                if (col.id === 'n_diasTomados') {
                                                    const reenderizar = (diasTomadosEditados === null);
                                                    return (
                                                        <TableCell key={col.id} align="center">
                                                            {esEditable ? (reenderizar ? row[col.id] : diasTomadosEditados[row.id_papeleta]) : (row[col.id])}
                                                        </TableCell>
                                                    );
                                                }
                                                if (col.id === 'estado') {
                                                    const estadoLabel =
                                                        row.estado === '1'
                                                            ? 'Pendiente'
                                                            : row.estado === '2'
                                                                ? 'Aprobado'
                                                                : row.estado === '3'
                                                                    ? 'Rechazado'
                                                                    : 'Sin estado';
                                                    return <TableCell key={col.id} align="center">{estadoLabel}</TableCell>;
                                                }
                                                if (col.id === 'acciones') {
                                                    return (
                                                        <TableCell key={col.id} align="center">
                                                            {row.estado === '2' && (
                                                                <IconButton
                                                                    title='Ver papeleta'
                                                                    size="small"
                                                                    color='info'
                                                                    style={{ border: 'solid 0.02rem', borderRadius: 0 }}
                                                                    onClick={() => download_papeleta(row.id_papeleta, `papeleta-${row.n_papeleta}`)}
                                                                >
                                                                    <PictureAsPdfTwoToneIcon fontSize="inherit" />
                                                                </IconButton>
                                                            )}
                                                            {(!TabMisAprobaciones && row.estado === '1') && (
                                                                editandoFilaId === row.id_papeleta ? (
                                                                    <>
                                                                        <IconButton
                                                                            title='Guardar cambios'
                                                                            size="small"
                                                                            color='primary'
                                                                            sx={{ border: '0.02rem solid', borderRadius: 0 }}
                                                                            onClick={() => EditarFechaPapeleta(row.id_papeleta)}
                                                                        // disabled={!sePuedeGuardar(row.id_papeleta)}
                                                                        >
                                                                            <SaveTwoToneIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            title="Cancelar edición"
                                                                            size="small"
                                                                            color="error"
                                                                            sx={{ border: '0.02rem solid', borderRadius: 0, ml: 1 }}
                                                                            onClick={() => {
                                                                                setEditandoFilaId(null);
                                                                                setDiasTomadosEditados(null);
                                                                                setValoresEditados({})
                                                                            }}
                                                                        >
                                                                            <CloseTwoToneIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <IconButton
                                                                            title='Editar papeleta'
                                                                            size="small"
                                                                            color='success'
                                                                            sx={{ border: '0.02rem solid', borderRadius: 0 }}
                                                                            onClick={() => {
                                                                                setDiasTomadosEditados({ [row.id_papeleta]: row['n_diasTomados'] })
                                                                                setEditandoFilaId(row.id_papeleta);
                                                                            }}
                                                                        >
                                                                            <EditTwoToneIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                        {/* <IconButton
                                                                            title='Aprobar papeleta'
                                                                            size="small"
                                                                            color='success'
                                                                            style={{ border: 'solid 0.02rem', borderRadius: 0, marginRight: '0.5rem' }}
                                                                            onClick={() => EnviarToken(row.id_papeleta)}
                                                                        ></IconButton> */}
                                                                    </>
                                                                )
                                                            )}
                                                            {TabMisAprobaciones && row.estado === '1' && (
                                                                <>
                                                                    <IconButton
                                                                        title='Aprobar papeleta'
                                                                        size="small"
                                                                        color='success'
                                                                        style={{ border: 'solid 0.02rem', borderRadius: 0, marginRight: '0.5rem' }}
                                                                        onClick={() => EnviarToken(row.id_papeleta)}
                                                                    // disabled={ archivosSubidos.find(item => item.id === row.id_papeleta) ? false : true }
                                                                    >
                                                                        <ThumbUpAltTwoToneIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        title='Desaprobar papeleta'
                                                                        size="small"
                                                                        color='success'
                                                                        style={{ border: 'solid 0.02rem', borderRadius: 0 }}
                                                                        onClick={() => DesaprobarPapeleta(row.id_papeleta, 3)}
                                                                        disabled={row.estado === '3' ? true : false}

                                                                    >
                                                                        <ThumbDownAltTwoToneIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                </>
                                                            )}
                                                        </TableCell>
                                                    );
                                                }
                                                return (
                                                    <TableCell key={col.id} align={col.align || 'left'}>
                                                        {row[col.id]}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            <VerificationModal
                open={modalAbierto}
                correoVerificacion={correo}
                onClose={() => setModalAbierto(false)}
                setOpenModalLoader={cambiarLoader}
                id_papeleta={actualizarPapeleta}
                EnviarToken={EnviarToken}
                QuePapeletasCargar={QuePapeletasCargar}
            />
        </div>
    );
} 